import { CommonModule } from '@angular/common';
import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { IconComponentV2 } from '../../../../../shared/components/icon-component/icon.component';
import { ButtonComponent } from '../../../../../shared/components/ui/button/button.component';
import {
  UnpaidPaymentsConfirmDialogData,
  UnpaidPaymentsConfirmDialogResult,
} from '../../unpaid-payments-modal.types';

@Component({
  selector: 'app-unpaid-payments-remove-modal',
  standalone: true,
  imports: [CommonModule, FormsModule, IconComponentV2, ButtonComponent],
  changeDetection: ChangeDetectionStrategy.Eager,
  templateUrl: './unpaid-payments-remove-modal.component.html',
})
export class UnpaidPaymentsRemoveModalComponent {
  private readonly dialogData = inject<UnpaidPaymentsConfirmDialogData>(MAT_DIALOG_DATA);
  private readonly dialogRef =
    inject<MatDialogRef<UnpaidPaymentsRemoveModalComponent, UnpaidPaymentsConfirmDialogResult | undefined>>(
      MatDialogRef
    );

  note = '';

  readonly mode = this.dialogData.mode;
  readonly isRemoveMode = this.mode === 'remove';
  readonly isConfirmMode = this.mode === 'confirm';

  readonly title = this.dialogData.title;
  readonly contractId = this.dialogData.contractId;
  readonly paymentCount = this.dialogData.paymentCount;
  readonly totalAmount = this.dialogData.totalAmount ?? 0;
  readonly confirmLabel = this.dialogData.confirmLabel ?? (this.isRemoveMode ? 'Remove' : 'Pay');
  readonly cancelLabel = this.dialogData.cancelLabel ?? 'Cancel';
  readonly inputPlaceholder = this.dialogData.inputPlaceholder ?? 'Enter note';
  readonly message = this.dialogData.message;
  readonly useTextarea = this.dialogData.useTextarea ?? false;
  readonly confirmDisabled = this.dialogData.confirmDisabled ?? false;
  readonly disabledMessage = this.dialogData.disabledMessage;

  get canSubmit(): boolean {
    if (this.confirmDisabled) return false;
    if (this.isRemoveMode) return !!this.note.trim();
    return true;
  }

  close(): void {
    this.dialogRef.close(undefined);
  }

  confirm(): void {
    if (!this.canSubmit) return;

    if (this.isRemoveMode) {
      const trimmed = this.note.trim();
      if (!trimmed) return;
      this.dialogRef.close({ confirmed: true, note: trimmed });
      return;
    }

    this.dialogRef.close({ confirmed: true });
  }
}
